<template>
  <form class="contact-form" @submit.prevent>
    <label for="fname">{{ $tc('home_page.contact_form_h_label1') }}</label>
    <input v-model="form.name" type="text" name="fname" class="input-f">

    <label for="email">{{ $tc('home_page.contact_form_h_label2') }} <span>*</span></label>
    <input
      v-model="form.email"
      type="email"
      name="email"
      class="input-f"
      :class="{ error: emailHasError }">
    <span v-if="emailHasError" class="input-error">This field is required!</span>

    <label for="email">{{ $tc('home_page.contact_form_h_label3') }} <span>*</span></label>
    <textarea v-model="form.message" class="input-f" rows="5" />
    <span v-if="messageHasError" class="input-error">{{ messageHasError }}</span>

    <button class="submit-btn" @click="submit()">{{ loading ? $tc('home_page.contact_form_btn1') : $tc('home_page.contact_form_btn2') }}</button>
  </form>
</template>

<script>
import axios from 'axios'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      form: {
        name: null,
        email: null,
        message: null
      },

      loading: false
    }
  },

  computed: {
    emailHasError () {
      return this.$v.form.$dirty && this.$v.form.email.$invalid
    },

    messageHasError () {
      const hasError = this.$v.form.$dirty && this.$v.form.message.$invalid
      if (!hasError) return null

      if (!this.$v.form.message.required) return 'This field is required!'
      if (!this.$v.form.message.maxLength) return 'This field is too long!'
      return null
    }
  },

  methods: {
    async submit () {
      this.$v.$touch()
      if (this.$v.form.$invalid) return

      this.loading = true
      try {
        await axios.post('/contact', this.form)
        this.clear()
        this.$store.commit('toast/add', {
          type: 'success',
          message: 'Thank you for contacting us! Will will get back to you shortly.'
        })
      } catch {
        this.$store.commit('toast/add', {
          type: 'error',
          message: 'There was an error. Please try again.'
        })
      } finally {
        this.loading = false
      }
    },

    clear () {
      this.form = {
        name: null,
        email: null,
        message: null
      }
    }
  },

  validations: {
    form: {
      email: { required },
      message: { required, maxLength: maxLength(1000) }
    }
  }
}
</script>
